import ConsulenzaTelematicaEdit from "./components/ConsulenzaTelematicaEdit.vue";
import ConsulenzaTelematicaView from "./components/ConsulenzaTelematicaView.vue";
import ConsulenzaTelematicaList from "./components/ConsulenzaTelematicaList.vue";

export default {
    ConsulenzaTelematicaEdit,
    ConsulenzaTelematicaView,
    ConsulenzaTelematicaList,
};
